<template>
  <div class="configNetPage">
    <!-- 第一部分: 基础信息 -->
    <div class="section-box">
      <ul class="base-info">
        <li v-for="item in baseMsg" :key="item.key">
          <span class="label">{{ $t(item.text) }}：</span>
          <span class="value">
            <template v-if="item.key === 'url'">
              {{ urlFn() }}
            </template>
            <template v-else-if="item.key === 'type' || item.key === 'status'">
              {{ textChange(item.key) }}
            </template>
            <template v-else>
              <i
                v-show="item.key === 'magnetismCode'"
                v-icon="['equiStatusConvert', rowData['status']]"
              ></i>
              {{ rowData[item.key] }}
            </template>
          </span>
        </li>
      </ul>
    </div>
    <!-- 第二部分: 配置参数 -->
    <div class="section-box">
      <el-form ref="form" label-width="auto" :model="dioForm" :rules="rules" label-position="right" label-suffix="：">
        <!-- 上报规则 -->
        <el-form-item :label="$t('device.sample_interval')" prop="collectInterval">
            <el-input
              v-if="!isClickConfig"
              v-model.trim="dioForm.collectInterval"
              style="width: 250px"
              maxlength="50"
              :placeholder="$t('public.please_enter')"
            />
          <template v-else-if="dioForm['collectInterval']">
            <span
              v-if="
                configStatus !== 2 &&
                  dioForm['collectIntervalCurrent'] &&
                  dioForm['collectIntervalCurrent'].change
              "
              >{{ dioForm['collectIntervalCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['collectIntervalCurrent']" style="color:red">{{
              dioForm['collectIntervalCurrent'].modify
            }}</span>
          </template>
          <template v-else>---</template>
        </el-form-item>
        <el-form-item :label="$t('integration.alarm_threshold')" prop="alarmThreshold">
            <el-input
              v-if="!isClickConfig"
              v-model.trim="dioForm.alarmThreshold"
              style="width: 250px"
              maxlength="50"
              :placeholder="$t('public.please_enter')"
            />
            <template v-else-if="dioForm['collectInterval']">
            <span
              v-if="
                configStatus !== 2 &&
                  dioForm['alarmThresholdCurrent'] &&
                  dioForm['alarmThresholdCurrent'].change
              "
              >{{ dioForm['alarmThresholdCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['alarmThresholdCurrent']" style="color:red">{{
              dioForm['alarmThresholdCurrent'].modify
            }}</span>
          </template>
          <template v-else>---</template>
        </el-form-item>
      </el-form>
      <div class="form-actions" v-if="configStatus !== 1">
        <el-button v-if="isClickConfig" type="primary" @click="configISFn"
          >{{ $t('public.config') }}
        </el-button>
        <template v-else>
          <el-button type="primary" @click="cancelFn"
            >{{ $t('public.cancel') }}
          </el-button>
          <el-button type="primary" @click="configSave"
            >{{ $t('public.save') }}
          </el-button>
        </template>
      </div>
    </div>
    <!-- 第三部分: Command (只有存在16进制命令时才显示) -->
    <div class="section-box" v-if="cmd">
      <el-form label-width="100px" label-position="right" label-suffix="：">
        <el-form-item :label="$t('public.command')">
          <span class="cmd-text">{{ cmd }}</span>
        </el-form-item>
      </el-form>
    </div>

    <!-- <ConfigList :sensor-info="rowData" :list="listArray"></ConfigList> -->
    <!-- 第四部分: 配置列表 -->
    <div class="section-box" v-if="listArray.length">
      <div class="list">
        <div class="listPage" v-for="item in listArray" :key="item.id">
          <span>{{ $timetransition(item['logTime']) }}</span>
          <span>{{ $t('integration.escalation_rules') }}</span>
          <span>{{ configFn(item['stepCode']) }}</span>
          <el-button
            type="text"
            size="small"
            :title="$t('public.details')"
            icon="el-icon-tickets"
            @click="showConfigDetail(item)"
          ></el-button>
        </div>
      </div>
    </div>

    <!-- 命令详情 -->
    <CmdDialog
      :isShow.sync="isShow"
      v-bind="$attrs"
      :title="title"
      :cmdObj="cmdObj"
      ref="configLogDia"
    />
  </div>
</template>

<script>
import { magnetismGetDetailConfig, magnetismUpdateAppConfig } from '@/api/modules/sensor'
import { configStatusConvert, configStep, magnetismType  } from '@/utils/convert'
import CmdDialog from './CmdDialog.vue'
// import ConfigList from '@/pages/equipment/sensor/components/sensor/cionfig/children/ConfigList.vue'
import addRules from '@/pages/equipment/validate/addRules.js'
import { getConfigLogContent } from '@/api/modules/deviceUrl'

export default {
  props: ['rowData'],
  computed: {
    // configStatus () {
    //   // 默认已配置
    //   if (this.sensorConfig) {
    //     return this.sensorConfig.status
    //   } else {
    //     return 2
    //   }
    // },
    rules () {
      const rules = addRules.call(this, 'rule', [
        'collectInterval',
        'alarmThreshold'
      ])
      return rules
    }
  },
  components: {
    // ConfigList,
    CmdDialog
  },
  data () {
    return {
      dioForm: {},
      baseMsg: [
        {
          key: 'url',
          text: 'public.belong'
        },
        {
          key: 'magnetismCode',
          text: 'integration.magnetism_code'
        },
        {
          key: 'status',
          text: 'device.config_status'
        },
        {
          key: 'carrierName',
          text: 'public.carrier'
        },
        {
          key: 'type',
          text: 'integration.gas_type'
        },
        {
          key: 'description',
          text: 'public.table_desc'
        }
      ],
      listArray: [],
      isShow: false,
      title: '',
      cmdObj: {},
      appConfig: null,
      sensorConfig: null,
      isClickConfig: true,
      cmd: null,

      // 配置状态
      configStatus: 2,
    }
  },
  mounted () {
    console.log('rowData==', this.rowData)
    this.getList()
  },
  methods: {
    getList () {
      if (
        this.$attrs.sensorWay === 'unknown' ||
        this.$attrs.sensorWay === 'unbind'
      ) {
        this.baseMsg.splice(3, 1)
      }
      magnetismGetDetailConfig(this.rowData.id).then(({ result }) => {
        const JsonContent = JSON.parse(result.content)
        this.cmd = JsonContent.cmd
        this.dioForm = {
          collectInterval: JsonContent.item.collectInterval.modify,
          collectIntervalCurrent: JsonContent.item.collectInterval,
          alarmThreshold: JsonContent.item.alarmThreshold.modify,
          alarmThresholdCurrent: JsonContent.item.alarmThreshold,
        }
        this.listArray = result.responseDeviceConfigLogList

        this.configStatus = result.status
      })
    },
    urlFn () {
      let url = this.rowData.sceneName
      if (this.rowData.structureName) {
        url += '/' + this.rowData.structureName
      }
      if (this.rowData.carrierName) {
        url += '/' + this.rowData.carrierName
      }
      return url
    },
    textChange (key) {
      if (key === 'status') {
        return this.$t(configStatusConvert(this.configStatus).title)
      } else if (key === 'type') {
        if (!this.rowData[key]) {
          return
        }

        return magnetismType[this.rowData[key]].title
      } else {
        return this.rowData[key]
      }
    },
    statusFn (key) {
      return key === 1 ? this.$t('public.online') : this.$t('public.offline')
    },
    configFn (value) {
      return this.$t(configStep[value].title)
    },
    listFn (array) {
      this.listArray = array
    },
    configISFn () {
      this.isClickConfig = !this.isClickConfig
    },
    cancelFn () {
      this.isClickConfig = true
      this.clearValidate()
    },
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async configSave () {
      this.loading = true
      const flag = await this.justify()
      if (!flag) return
      const { collectInterval, alarmThreshold } = this.dioForm
      const query = {
        collectInterval,
        alarmThreshold,
        idList: [this.rowData.id]
      }
      magnetismUpdateAppConfig(query)
        .then(({ result, state }) => {
          if (result && state.code === 200) {
            this.$message.success($t('integration.update_successful'))
            this.isClickConfig = !this.isClickConfig
            this.getList()
          } else {
            this.$message.error(state.msg)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 查看配置详情
    showConfigDetail (row) {
      this.isShow = true
      this.title = `[${
        row.deviceName
      }][${$t('integration.escalation_rules')}] ${$t('integration.configuration_details')} [${this.$timetransition(row.logTime)}]`

      getConfigLogContent({ configLogId: row.id }, 'gas').then(
        ({ result }) => {
          if (result) {
            const JsonContent = JSON.parse(result.content)
            let childrenContent = ''
            if (JsonContent.content) {
              childrenContent = JSON.parse(JsonContent.content)
            }
            let url = this.rowData.sceneName
            if (this.rowData.sceneName) {
              url += '/' + this.rowData.sceneName
            }
            if (this.rowData.carrierName) {
              url += '/' + this.rowData.carrierName
            }
            this.cmdObj = {
              url: url,
              carrierName: this.rowData.carrierName,
              magnetismCode: JsonContent.deviceName,
              deviceType: JsonContent.deviceType,
              status: JsonContent.status,
              step: result.stepCode,
              type: JsonContent.type,
              // 从外层获取详细
              description: this.rowData.description,
              configStatus: this.configStatus,
              // content 内容
              cmd: JSON.parse(JsonContent.content).cmd,

              ...JSON.parse(JsonContent.content).item

            }
          } else {
            this.cmdObj = {}
          }
        })

    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  height: 700px;
  overflow: auto;

  .section-box {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-left: 3px solid var(--primary-color, #409eff);
    border-radius: 4px;
    padding: 14px 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .base-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;

    li {
      display: contents;
    }

    .label {
      text-align: right;
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }

    .value {
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }
  }

  .form-actions {
    text-align: right;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #e4e7ed;
  }

  .list {
    max-height: 200px;
    overflow: auto;
  }

  .listPage {
    height: 40px;
    width: 100%;
    margin-top: 15px;
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    > span {
      margin-right: 30px;
    }

    > .el-button {
      margin-left: auto;
    }
  }

  .cmd-text {
    word-break: break-all;
    font-family: Consolas, Monaco, monospace;
    color: #303133;
  }
}
</style>
